module.exports = __webpack_public_path__ + "static/media/1011092.94a3b7c5.jpg";